import React from "react";
import styles from "./index.module.css";
import { IoShieldCheckmarkSharp } from "react-icons/io5";

const PackageSection = () => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>PRICE PLANS</div>
      <div className={styles.subHeading}>BEST CHOICE FOR YOUR BUSINESS</div>
      <div className={styles.card}>
        <div className={styles.left}>
          <h2>LKR</h2>
          <h1>1500</h1>
          <h3>/ PER MONTH</h3>
        </div>
        <div className={styles.right}>
          <div className={styles.topContainer}>
            <div className={styles.top}>
              <IoShieldCheckmarkSharp style={{ color: "white" }} />
              <h3>
                {" "}
                <b>Unlimited </b>access for all services
              </h3>
            </div>
            <div className={styles.top}>
              <IoShieldCheckmarkSharp style={{ color: "white" }} />
              <h3>Advanced Reporting & Analytics</h3>
            </div>
            <div className={styles.top}>
              <IoShieldCheckmarkSharp style={{ color: "white" }} />
              <h3>Priority Customer Support</h3>
            </div>
            <div className={styles.top}>
              <IoShieldCheckmarkSharp style={{ color: "white" }} />
              <h3>Offline Mode (Auto Sync)</h3>
            </div>
            <div className={styles.top}>
              <IoShieldCheckmarkSharp style={{ color: "white" }} />
              <h3>Data Security & Backup</h3>
            </div>
          </div>
          <div className={styles.bottomContainer}>
            <a href="https://onboard.epinics.com/" target="_blank">
              <div className={styles.buttonDiv}>
                <h2>START FREE TRIAL</h2>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageSection;
